import { resetObjectValues } from '@/utils';
import { reactive, ref } from 'vue';
/**
 * @description useReportPage 接收一个 opts 参数，返回列表所需数据
 * @param {Object} opts.searchForm - 默认查询参数
 * @param {Function} opts.onBeforeRequest  - 查询列表数据前对参数的校验, 默认返回true
 * @param {Function} opts.getListApi  - 获取列表数据的接口
 * @param {Function} opts.usePagination  - 是否使用分页 不传默认使用
 * @param {Function} opts.customQueryParameters  - 自定义查询参数
 * @param {Function} opts.getListFunc  - 执行完 getList 成功后执行的逻辑 有一个opts参数
 * @param {Function} opts.resetFunc  - 执行完 reset 后执行的逻辑
 * @param {Function} opts.sizeChangeFunc  - 执行完 sizeChange 后执行的逻辑
 * @param {Function} opts.currentChangeFunc  - 执行完 currentChange 后执行的逻辑
 */
export const useReportPage = (opts: any) => {
  // searchForm 由外部传入，内部传入导出的数据无法推导类型即无法知道对象里有什么也会失去代码提示
  const {
    searchForm = {},
    getListApi,
    onBeforeRequest = () => true,
    customQueryParameters = () => ({}),
    getListFunc = () => ({}),
    resetFunc = () => ({}),
    sizeChangeFunc = () => ({}),
    currentChangeFunc = () => ({}),
    usePagination = true,
  } = opts;

  const page = reactive({
    pageSize: 20,
    pageNum: 1,
    total: 0,
  });

  const loading = ref(false);
  const tableData = ref();

  const getList = async (hideLoading = false) => {
    if (!onBeforeRequest()) {
      return;
    }

    if (!hideLoading) {
      loading.value = true;
    }
    const params = {
      ...searchForm,
      ...customQueryParameters(),
    };
    if (usePagination) {
      params.pageSize = page.pageSize;
      params.pageNum = page.pageNum;
    }

    try {
      await getListApi(params).then((res: {
        code: number;
        data: {
          list: never[];
          total: number;
        }
      }) => {
        tableData.value = res?.data?.list || [];
        page.total = res?.data?.total || 0;
        getListFunc(res);
      }).finally(() => {
        loading.value = false;
      });
    } catch (error) {
      console.error('error:', error);
    }
  };

  const handleSizeChange = (size: number) => {
    page.pageNum = 1;
    page.pageSize = size;
    sizeChangeFunc();
    getList();
  };

  const handleCurrentChange = async (cur: number, hideLoading = false) => {
    page.pageNum = cur;
    currentChangeFunc();
    await getList(hideLoading);
  };

  const reset = () => {
    Object.assign(searchForm, resetObjectValues(searchForm));
    resetFunc();
    handleCurrentChange(1);
  };

  return {
    loading,
    searchForm,
    reset,
    page,
    tableData,
    handleSizeChange,
    handleCurrentChange,
  };
};
